<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="AttnGroupListFilter" :model="AttnGroupList" :size="defaultFormItemSize"
      label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350">
        <el-form-item label="考勤组名称" prop="formFilter.name">
          <el-input class="filter-item" v-model="AttnGroupList.formFilter.name"
            :clearable="true" placeholder="名称"
          />
        </el-form-item>
        <el-form-item label="允许外勤" prop="formFilter.anywhereFlag">
          <el-select class="filter-item" v-model="AttnGroupList.formFilter.anywhereFlag" :clearable="true" filterable
            placeholder="允许外勤" :loading="AttnGroupList.anywhereFlag.impl.loading"
            @visible-change="AttnGroupList.anywhereFlag.impl.onVisibleChange"
            @change="onAnywhereFlagValueChange">
            <el-option v-for="item in AttnGroupList.anywhereFlag.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
          </el-select>
        </el-form-item>
        <el-form-item label="登录账号" prop="formFilter.loginName">
          <el-input class="filter-item" v-model="AttnGroupList.formFilter.loginName"
            :clearable="true" placeholder="登录账号"
          />
        </el-form-item>
        <el-form-item label="员工姓名" prop="formFilter.showName">
          <el-input class="filter-item" v-model="AttnGroupList.formFilter.showName"
            :clearable="true" placeholder="员工姓名"
          />
        </el-form-item>
        <el-form-item label="所属部门" prop="formFilter.deptId">
          <el-select class="filter-item" v-model="AttnGroupList.formFilter.deptId" :clearable="true" filterable
            placeholder="所属部门" :loading="AttnGroupList.deptId.impl.loading"
            @visible-change="AttnGroupList.deptId.impl.onVisibleChange"
            @change="onDeptIdValueChange">
            <el-option v-for="item in AttnGroupList.deptId.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
          </el-select>
        </el-form-item>
        <el-form-item label="假期年度" prop="formFilter.year">
          <el-date-picker class="filter-item" v-model="year" :clearable="true"
                          format="yyyy" value-format="yyyy" type="year" align="left" placeholder="年度"
          />
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="syncPaHoliday">同步假期</el-button>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetAttnGroupList">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshAttnGroupList(true)">查询</el-button>
      </filter-box>
    </el-form>
    <el-form ref="AttnGroupList" :model="formData" class="full-width-input" style="width: 100%;"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="8" class="gutter-bottom">
          <el-card class="base-card" shadow="never">
            <div slot="header" class="base-card-header">
              <span>考勤组列表</span>
              <div class="base-card-operation">
                <el-button @click="onAddAttnGroupClick()" type="primary" :size="defaultFormItemSize"
                  :disabled="!checkPermCodeExist('AttnGroupList:AttnGroupList:AddAttnGroup')">
                  添加
                </el-button>
              </div>
            </div>
            <el-row class="no-scroll flex-box" :gutter="20" type="flex" justify="">
              <el-col class="table-box gutter-bottom" :span="24">
                <el-table ref="paAttnGroup" :data="AttnGroupList.PaAttnGroup.impl.dataList" :size="defaultFormItemSize" @sort-change="AttnGroupList.PaAttnGroup.impl.onSortChange"
                  header-cell-class-name="table-header-gray"
                  highlight-current-row @current-change="AttnGroupList.PaAttnGroup.impl.currentRowChange"
                >
                  <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="AttnGroupList.PaAttnGroup.impl.getTableIndex" />
                  <el-table-column label="名称" prop="name">
                  </el-table-column>
                  <el-table-column label="允许外勤" prop="anywhereFlagDictMap.name">
                  </el-table-column>
                  <el-table-column label="描述" prop="detail">
                  </el-table-column>
                  <el-table-column label="备注" prop="remark">
                  </el-table-column>
                  <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                      <el-button @click.stop="onDeleteClick(scope.row)" type="text" :size="defaultFormItemSize"
                        :disabled="!checkPermCodeExist('AttnGroupList:AttnGroupList:delete')||scope.row.id===0">
                        删除
                      </el-button>
                      <el-button @click.stop="onEditAttnGroupClick(scope.row)" type="text" :size="defaultFormItemSize"
                        :disabled="!checkPermCodeExist('AttnGroupList:AttnGroupList:EditAttnGroup')||scope.row.id===0">
                        编辑
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
        <el-col :span="16" class="gutter-bottom">
          <el-card class="base-card" shadow="never">
            <div slot="header" class="base-card-header">
              <span>考勤人员</span>
              <div class="base-card-operation">
                <el-button @click="onEmptyUserClick()" type="primary" :size="defaultFormItemSize"
                  :disabled="!checkPermCodeExist('AttnGroupList:AttnGroupList:emptyUser') || !emptyUserEnabled">
                  清空人员
                </el-button>
                <el-button @click="onSelectUserClick()" type="primary" :size="defaultFormItemSize"
                  :disabled="!checkPermCodeExist('AttnGroupList:AttnGroupList:SelectUser') || !emptyUserEnabled">
                  选择员工
                </el-button>
              </div>
            </div>
            <el-row class="no-scroll" :gutter="20">
              <el-col class="table-box gutter-bottom" :span="24">
                <el-table ref="sysUser" :data="AttnGroupList.SysUser.impl.dataList" :size="defaultFormItemSize" @sort-change="AttnGroupList.SysUser.impl.onSortChange"
                  header-cell-class-name="table-header-gray"
                >
                  <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="AttnGroupList.SysUser.impl.getTableIndex" />
                  <el-table-column label="登录用户名" prop="loginName">
                  </el-table-column>
                  <el-table-column label="用户显示名称" prop="showName">
                  </el-table-column>
                  <el-table-column label="所属部门" prop="deptIdDictMap.name">
                  </el-table-column>
                  <el-table-column label="职位状态" prop="jobStatusDictMap.name">
                  </el-table-column>
                  <el-table-column label="性别" prop="genderDictMap.name">
                  </el-table-column>
                  <el-table-column label="工龄" prop="workYears">
                  </el-table-column>
                  <el-table-column label="薪级" prop="jobLevelIdDictMap.name" width="130px">
                  </el-table-column>
                  <el-table-column label="职称" prop="jobTitleIdDictMap.name" width="100px">
                  </el-table-column>
                  <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                      <el-button @click.stop="onEditUserInfoClick(scope.row)" type="text" :size="defaultFormItemSize"
                        :disabled="!checkPermCodeExist('AttnGroupList:AttnGroupList:EditUserInfo')">
                        编辑
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-row type="flex" justify="end" style="margin-top: 10px;">
                  <el-pagination
                    :total="AttnGroupList.SysUser.impl.totalCount"
                    :current-page="AttnGroupList.SysUser.impl.currentPage"
                    :page-size="AttnGroupList.SysUser.impl.pageSize"
                    :page-sizes="[10, 20, 50, 100]"
                    layout="total, prev, pager, next, sizes"
                    @current-change="AttnGroupList.SysUser.impl.onCurrentPageChange"
                    @size-change="AttnGroupList.SysUser.impl.onPageSizeChange">
                  </el-pagination>
                </el-row>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
    </el-form>
    <label v-if="closeVisible == '1'" class="page-close-box">
      <el-button type="text" @click="onCancel(true)" icon="el-icon-close" />
    </label>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import {PaAttnGroupController, SysUserController, DictionaryController} from '@/api';
import addAttnGroup from '@/views/AttnManage/addAttnGroup.vue';
import selectUser from '@/views/UserInfo/selectUser.vue';

export default {
  name: 'AttnGroupList',
  props: {
    closeVisible: {
      type: [Number, String],
      default: 0
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin],
  data () {
    return {
      year: undefined,
      formData: {
        PaAttnGroup: {
          id: undefined,
          name: undefined,
          anywhereFlag: undefined,
          detail: undefined,
          remark: undefined,
          deletedFlag: undefined,
          paAttnGroupLine: {
          },
          sysUser: {
          },
          isDatasourceInit: false
        },
        SysUser: {
          attnGroupId: undefined,
          userId: undefined,
          loginName: undefined,
          password: undefined,
          deptId: undefined,
          deptTid: undefined,
          showName: undefined,
          userType: undefined,
          headImageUrl: undefined,
          userStatus: undefined,
          deletedFlag: undefined,
          createUserId: undefined,
          updateUserId: undefined,
          createTime: undefined,
          updateTime: undefined,
          jobLevelFilePath: undefined,
          gender: undefined,
          entryTime: undefined,
          jobStatus: undefined,
          workStatus: undefined,
          regularTime: undefined,
          workYears: undefined,
          birthDate: undefined,
          jobLevelId: undefined,
          jobTitleId: undefined,
          indexGroupId: undefined,
          email: undefined,
          mobilePhone: undefined,
          landlinePhone: undefined,
          emContact1: undefined,
          emContact1Tel: undefined,
          emContact2: undefined,
          emContact2Tel: undefined,
          isDatasourceInit: false
        }
      },
      AttnGroupList: {
        formFilter: {
          name: undefined,
          anywhereFlag: undefined,
          loginName: undefined,
          showName: undefined,
          deptId: undefined,
          year: undefined
        },
        formFilterCopy: {
          name: undefined,
          anywhereFlag: undefined,
          loginName: undefined,
          showName: undefined,
          deptId: undefined
        },
        PaAttnGroup: {
          impl: new TableWidget(this.loadPaAttnGroupWidgetData, this.loadPaAttnGroupVerify, false, true, 'name', 1)
        },
        SysUser: {
          impl: new TableWidget(this.loadSysUserWidgetData, this.loadSysUserVerify, true, false, 'showName', 1)
        },
        anywhereFlag: {
          impl: new DropdownWidget(this.loadAnywhereFlagDropdownList)
        },
        deptId: {
          impl: new DropdownWidget(this.loadDeptIdDropdownList)
        },
        AttnGroupListDiv: {
          isInit: false
        },
        UserListDiv: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    onCancel (isSuccess) {
      this.removeCachePage(this.$options.name);
      this.refreshParentCachedPage = isSuccess;
      this.$router.go(-1);
    },
    syncPaHoliday () {
      if (!this.year) {
        this.$message.error('请填写同步工作日节假日年度!');
        return;
      }
      this.$confirm('是否同步工作日节假日?年度:' + this.year).then(res => {
        let params = {year: this.year};
        PaAttnGroupController.syncPaHoliday(this, params).then(res => {
          this.$message.success(res.data);
        });
      });
    },
    onResetAttnGroupList () {
      this.$refs.AttnGroupListFilter.resetFields();
      this.refreshAttnGroupList(true);
    },
    /**
     * 考勤组数据获取函数，返回Promise
     */
    loadPaAttnGroupWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        paAttnGroupDtoFilter: {
          name: this.AttnGroupList.formFilterCopy.name,
          anywhereFlag: this.AttnGroupList.formFilterCopy.anywhereFlag
        }
      }
      return new Promise((resolve, reject) => {
        PaAttnGroupController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
          // 恢复当前选择行
          if (this.AttnGroupList.PaAttnGroup.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.AttnGroupList.PaAttnGroup.impl.currentRow.id, 'id');
              this.$refs.paAttnGroup.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 考勤组数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadPaAttnGroupVerify () {
      this.AttnGroupList.formFilterCopy.name = this.AttnGroupList.formFilter.name;
      this.AttnGroupList.formFilterCopy.anywhereFlag = this.AttnGroupList.formFilter.anywhereFlag;
      return true;
    },
    /**
     * 用户管理数据获取函数，返回Promise
     */
    loadSysUserWidgetData (params) {
      if (!this.AttnGroupList.PaAttnGroup.impl.currentRow) {
        return;
      }
      if (params == null) params = {};
      params = {
        ...params,
        sysUserDtoFilter: {
          attnGroupId: (this.AttnGroupList.PaAttnGroup.impl.currentRow || {}).id,
          loginName: this.AttnGroupList.formFilterCopy.loginName,
          deptTid: this.AttnGroupList.formFilterCopy.deptId,
          showName: this.AttnGroupList.formFilterCopy.showName
        }
      }
      return new Promise((resolve, reject) => {
        SysUserController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 用户管理数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadSysUserVerify () {
      this.AttnGroupList.formFilterCopy.loginName = this.AttnGroupList.formFilter.loginName;
      this.AttnGroupList.formFilterCopy.deptId = this.AttnGroupList.formFilter.deptId;
      this.AttnGroupList.formFilterCopy.showName = this.AttnGroupList.formFilter.showName;
      return true;
    },
    /**
     * 允许外勤下拉数据获取函数
     */
    loadAnywhereFlagDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictYN(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 允许外勤选中值改变
     */
    onAnywhereFlagValueChange (value) {
    },
    /**
     * 所属部门下拉数据获取函数
     */
    loadDeptIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        /** DictionaryController.dictSysDeptByParentId(this, params).then(res => {*/
          DictionaryController.dictSysDictDaLeiMingCheng(this, params).then(res => {
            resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 所属部门选中值改变
     */
    onDeptIdValueChange (value) {
    },
    /**
     * 更新考勤组列表
     */
    refreshAttnGroupListDivWidget (reloadData = false) {
      // 更新容器下所有的数据组件
      if (reloadData) {
        this.AttnGroupList.PaAttnGroup.impl.refreshTable(true, 1);
      } else {
        this.AttnGroupList.PaAttnGroup.impl.refreshTable();
      }
      this.AttnGroupList.AttnGroupListDiv.isInit = true;
    },
    /**
     * 更新考勤人员
     */
    refreshUserListDivWidget (reloadData = false) {
      // 更新容器下所有的数据组件
      if (reloadData) {
        this.AttnGroupList.SysUser.impl.refreshTable(true, 1);
      } else {
        this.AttnGroupList.SysUser.impl.refreshTable();
      }
      this.AttnGroupList.UserListDiv.isInit = true;
    },
    /**
     * 更新考勤组
     */
    refreshAttnGroupList (reloadData = false) {
      if (reloadData) {
        this.AttnGroupList.PaAttnGroup.impl.refreshTable(true, 1);
      } else {
        this.AttnGroupList.PaAttnGroup.impl.refreshTable();
      }
      if (reloadData) {
        this.AttnGroupList.SysUser.impl.refreshTable(true, 1);
      } else {
        this.AttnGroupList.SysUser.impl.refreshTable();
      }
      if (!this.AttnGroupList.isInit) {
        // 初始化下拉数据
      }
      this.AttnGroupList.isInit = true;
    },
    /**
     * 清空人员
     */
    onEmptyUserClick () {
      this.$refs.AttnGroupList.validate((valid) => {
        if (!valid) return;
        let params = {
          id: (this.AttnGroupList.PaAttnGroup.impl.currentRow || {}).id
        };

        this.$confirm('是否清空人员?').then(res => {
          PaAttnGroupController.emptyUser(this, params).then(res => {
            this.$message.success('清空人员成功');
            this.refreshUserListDivWidget();
          }).catch(e => {});
        }).catch(e => {});
      });
    },
    /**
     * 选择员工
     */
    onSelectUserClick () {
      let params = {};
      let that = this;
      this.$dialog.show('选择员工', selectUser, {
        area: '1100px', offset: '10px'
      }, params).then(res => {
        if (res.length === 0) {
          return;
        }
        let row = that.AttnGroupList.PaAttnGroup.impl.currentRow;
        PaAttnGroupController.adduser(this, {paAttnGroupDto: row, sysUserDtoList: res}).then(res => {
          this.refreshUserListDivWidget();
        }).catch(e => {});
      }).catch(e => {});
    },
    /**
     * 编辑
     */
    onEditUserInfoClick (row) {
      let params = {
        userId: row.userId
      };

      params.closeVisible = 1;
      this.$router.push({name: 'EditUserInfo', query: params});
    },
    /**
     * 删除
     */
    onDeleteClick (row) {
      let params = {
        id: row.id
      };

      this.$confirm('是否删除?').then(res => {
        PaAttnGroupController.delete(this, params).then(res => {
          this.$message.success('删除成功');
          this.AttnGroupList.PaAttnGroup.impl.refreshTable();
        }).catch(e => {});
      }).catch(e => {});
    },
    /**
     * 添加
     */
    onAddAttnGroupClick () {
      let params = {};

      this.$dialog.show('添加', addAttnGroup, {
        area: '400px'
      }, params).then(res => {
        this.refreshAttnGroupListDivWidget();
      }).catch(e => {});
    },
    /**
     * 编辑
     */
    onEditAttnGroupClick (row) {
      let params = {
        id: row.id
      };

      params.closeVisible = 1;
      this.$router.push({name: 'EditAttnGroup', query: params});
    },
    onResume () {
      this.refreshAttnGroupList(true);
    },
    initFormData () {
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        PaAttnGroup: {
          id: undefined,
          name: undefined,
          anywhereFlag: undefined,
          detail: undefined,
          remark: undefined,
          deletedFlag: undefined,
          paAttnGroupLine: {
          },
          sysUser: {
          },
          isDatasourceInit: false
        },
        SysUser: {
          attnGroupId: undefined,
          userId: undefined,
          loginName: undefined,
          password: undefined,
          deptId: undefined,
          deptTid: undefined,
          showName: undefined,
          userType: undefined,
          headImageUrl: undefined,
          userStatus: undefined,
          deletedFlag: undefined,
          createUserId: undefined,
          updateUserId: undefined,
          createTime: undefined,
          updateTime: undefined,
          jobLevelFilePath: undefined,
          gender: undefined,
          entryTime: undefined,
          jobStatus: undefined,
          workStatus: undefined,
          regularTime: undefined,
          workYears: undefined,
          birthDate: undefined,
          jobLevelId: undefined,
          jobTitleId: undefined,
          indexGroupId: undefined,
          email: undefined,
          mobilePhone: undefined,
          landlinePhone: undefined,
          emContact1: undefined,
          emContact1Tel: undefined,
          emContact2: undefined,
          emContact2Tel: undefined,
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshAttnGroupList();
    }
  },
  computed: {
    emptyUserEnabled () {
      return this.AttnGroupList.PaAttnGroup.impl.currentRow != null;
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
    // 考勤组选择行数据变化
    'AttnGroupList.PaAttnGroup.impl.currentRow': {
      handler (newValue) {
        this.AttnGroupList.SysUser.impl.refreshTable(true, 1);
      },
      immediate: true
    }
  }
}
</script>
